<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <picture-select :id="safeId()" v-model="localValue" :album-id="albumId"></picture-select>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'picture-select-group',
    props: {
      label: {default: 'Picture'},
      value: {required: true},
      albumId: {required: true}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/picture-select-group.vue